<template>
<div>

    <div class="box partner-box" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/missionlane.png" alt="Mission Lane Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/partners/missionlane.png" alt="Mission Lane Logo">
          </div>
            <br>
            <p>In partnership with Mission Lane, WebBank is the issuer and lender of the Mission Lane Visa credit card.
                If you have questions about your account, please contact Mission Lane at (855) 790-8860.</p>
            <br>
            <p><a href="#" title="Mission Lane Cardholder Agreement" @click="$emit('link-click', 'https://www.missionlane.com/legal/the-mission-lane-visa-credit-card-issued-by-webbank')">Mission Lane Cardholder Agreement</a></p>
            <br>
            <p><a href="#" title="Mission Lane Privacy Policy and Privacy Notice" @click="$emit('link-click', 'https://www.missionlane.com/legal/privacy-policy')">Mission Lane Privacy Policy and Privacy Notice</a></p>
            <br>
            <p><a href="#" title="WebBank Privacy Notice" @click="$emit('link-click', 'https://cdn.prod.website-files.com/5fd1c996d8285b5faf5273c9/659ed03ac36b4ea7d822963b_SV30%20Privacy%20Notice%20GLBA_Mission%20Lane%20(2).pdf')">WebBank Privacy Notice</a></p>
            <br>
            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
